export default "__VITE_ASSET__275325b5__"